export const LoggerActions = {
    LOGIN: 'login',
    CHANGE: 'change',
    CREATE: 'create'
}